import { render } from "./AssignmentList.vue?vue&type=template&id=9e050804"
import script from "./AssignmentList.vue?vue&type=script&lang=js"
export * from "./AssignmentList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__